<template>
  <div class="parentReport">
    <div class="positionbtns">
      <button
        class="butt"
        style="background-color: #6372ff"
        @click="downloadPdf('print')"
      >
        打印
      </button>
      <button
        class="butt"
        style="background-color: #6372ff"
        @click="downloadImg"
      >
        导出图片
      </button>
      <button
        class="butt"
        style="background-color: #6372ff"
        @click="downloadPdf"
      >
        导出pdf
      </button>
    </div>
    <!-- 从这里开始打印 -->
    <div id="myChart" class="myChart">
      <div id="pdfcontent" ref="reportBox" class="report-box">
        <div class="department-container">
          <div class="header">
            <div class="title">《{{ list.title }}结果分析》</div>
            <div class="userInfo">
              <div class="name">姓名：{{ list.customName }}</div>
              <div class="timer">测评时间：{{ list.testTime }}</div>
            </div>
          </div>
          <div class="main">
            <div class="test">
              <div class="test_content">
                <div class="left_logo">
                  <img src="./images/yq.png" alt="" />
                </div>
                <div class="left_title">测试结果</div>
                <div class="x"></div>
                <div class="right_title">Test result</div>
              </div>
              <div class="exponent">
                <div class="left">
                  您的焦虑指数为：<span>{{ result[0].Total }}</span>
                </div>
                <div class="right">
                  <img src="./images/rightlogo.png" alt="" />
                </div>
              </div>
            </div>
            <div class="test">
              <div class="test_content">
                <div class="left_logo">
                  <img src="./images/yq.png" alt="" />
                </div>
                <div class="left_title">结果分析</div>
                <div class="x"></div>
                <div class="right_title">Result analysis</div>
              </div>
              <div class="result">
                <div class="top">
                  <div class="title">
                    <div class="title_t">
                      <span
                        v-if="result[0].Total < 50"
                        style="color: #12a072; font-weight: bold"
                        >{{ list.description }}</span
                      >
                      <span v-else style="color: #ff5925; font-weight: bold">{{
                        list.description
                      }}</span>
                      如果对你的生活造成影响，还请咨询心理医生。本测试结果只作为参考，不能为诊断的结果。
                    </div>
                    <div class="title_b">以下四种方法供大家参考：</div>
                  </div>
                </div>
                <div class="body">
                  <div class="body_top">
                    <div class="body_header">
                      <img src="./images/sj.png" alt="" />
                    </div>
                    <div class="body_title">经常鼓励自己</div>
                  </div>
                  <div class="body_btn">
                    消极自卑的情绪是促使焦虑症产生的一个重要因素。如果一个人经常处于精神紧张或是自卑的状态，那时间长了，这个人便会很容易出现心情烦躁，看见什么都不顺心，容易对人发脾气等等一些焦躁的表现。
                    若发现自己有一点焦躁情绪的时候，就要对自己实行鼓励措施，可以面对镜子做出微笑的表情，或是每天对自己说几次“我能行〞，这种做法可以有效地缓解焦虑情绪。
                  </div>
                </div>
                <div class="body">
                  <div class="body_top">
                    <div class="body_header">
                      <img src="./images/sj.png" alt="" />
                    </div>
                    <div class="body_title">进行适当的锻炼</div>
                  </div>
                  <div class="body_btn">
                    适当的体育锻炼不仅可以强身健体，还可以释放人体的多巴胺，有效地缓解人的焦虑情绪，将体内悲观的情绪释放出去，使心情保持愉悦。如果生活中因为压力而有些焦虑时，可以尝试着去跑跑步，打打篮球或是羽毛球等，因为运动可以转移人的注意力，使其暂时将压力放下，让身心放松下来，不去想那些事情，那么人的整个的状态就会好很多。
                  </div>
                </div>
                <div class="body">
                  <div class="body_top">
                    <div class="body_header">
                      <img src="./images/sj.png" alt="" />
                    </div>
                    <div class="body_title">做自己喜欢的事情</div>
                  </div>
                  <div class="body_btn">
                    做自己喜欢或感兴趣的事情可以在很大成程度上放松人的心情，使人的整个神经完全松弛下来，这对于缓解焦虑也起到一个很好的作用。因为人对于自己喜欢的事情往往会全身心的投入，这样所有的烦恼就会被抛之脑后，也就很难再焦虑了。
                  </div>
                </div>
                <div class="body">
                  <div class="body_top">
                    <div class="body_header">
                      <img src="./images/sj.png" alt="" />
                    </div>
                    <div class="body_title">学会释放情绪</div>
                  </div>
                  <div class="body_btn">
                    学会释放情绪对于缓解焦虑也有很好的效果。人一旦出现焦虑情绪以后，心情就会变得相当复杂，心理状态也极其不平衡，这时候应该学着把心里的情绪宣泄出来，这些情绪释放出来自然就不会影响人的情绪，人也就不会变得焦躁不安，体内的压力得到释放，整个人也会显得轻松自在，精力充沛。其实，释放情绪的方式有很多种，可以选择去跑步，或是到一个空旷的地方大喊一声等，这些方法都可以使人舒心畅快，有效地缓解焦虑状态。
                    <div class="a">
                      学会这4种焦虑症的自我治疗，在焦虑情绪刚刚产生的时候就把它们扼杀。
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="base">
            <div class="leftlogo">
              <div class="base_logo" style="width: 200px">
                <img src="./images/log.png" alt="" />
              </div>
            </div>
            <div class="rightlogo">
              <div class="base_wenzi" style="margin-right: 20px">
                长按识别二维码 你也来测试一下吧～
              </div>
              <div class="base_logo"><img src="./images/ewm.png" alt="" /></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import ExportSavePdf from "@/utils/html2pdf";
import { formatTime } from "@/utils/index.js";
import { GetCustomScaleExplains } from "@/api/home";
export default {
  name: "HSasAnxiety",
  props: {},
  data() {
    return {
      widths: "300px",
      homeData: "",
      result: "",
      list: "",
    };
  },

  async mounted() {
    const res = await GetCustomScaleExplains(this.$route.query.CustomScaleId);
    this.result = JSON.parse(res.data.result);
    this.list = res.data||res.result;
  },

  methods: {
    // 导出pdf
    downloadPdf(type) {
      ExportSavePdf(
        "pdfcontent",
        `${this.list.customName}的个人报告`,
        formatTime(new Date()),
        type
      );
    },
    /**
     * 下载图片
     */
    downloadImg() {
      console.log("download ....");
      html2canvas(document.querySelector("#myChart")).then((canvas) => {
        const url = canvas.toDataURL();
        this.downloadFile(url, `${this.list.customName}的个人报告`);
      });
    },
    /**
     * @description Base64转Blob
     * @param dataUrl base64地址
     */
    dataURLtoBlob(dataurl) {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    /**
     * @description 构建a标签，通过a标签下载文件
     * @param url 下载地址
     * @param name 下载的文件名
     */
    downloadFile(url, name = "图片") {
      const a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", name);
      a.setAttribute("target", "_blank");
      const clickEvent = document.createEvent("MouseEvents");
      clickEvent.initEvent("click", true, true);
      a.dispatchEvent(clickEvent);
    },
    /**
     * @description 将得到的base64文件转码下载
     * @param base64 图片base64编码
     * @param name 文件名称
     */
    downloadFileByBase64(base64, name) {
      const myBlob = this.dataURLtoBlob(base64);
      const myUrl = URL.createObjectURL(myBlob);
      this.downloadFile(myUrl, name);
    },
  },
};
</script>

<style lang="less" scoped media="print">
@media print {
  @page {
    margin: 0;
  }
  body {
    margin: 0 1mm 1cm 0; // 此处样式根据实际需要进行设置
  }
}
.parentReport {
  .positionbtns {
    position: fixed;
    width: 100px;
    transform: translateX(467px);
    top: 85px;
    left: 0;
    right: 0;
    margin: auto;
    text-align: right;
    z-index: 1000;
    .butt {
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      margin-bottom: 15px;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      border-radius: 3px;
      border: 0;
      //   box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);
    }
  }
  .report-box {
    width: 794px;
    margin: 0 auto;
    background: #fff;
    .department-container {
      width: 100%;
      font-size: 12px;
      background-image: url("./images/background1.png") !important;
      padding-bottom: 1em;
      box-sizing: border-box;
      background-size: cover;
      .base {
        display: flex;
        justify-content: space-evenly;
        .leftlogo {
          display: flex;
          align-items: center;
          .base_logo {
            width: 35px;
            height: 35px;
            img {
              width: 100%;
            }
          }
          .base_wenzi {
            font-size: 16px;
            color: #fff;
          }
        }
        .rightlogo {
          display: flex;
          align-items: center;
          .base_wenzi {
            font-size: 16px;
            color: #fff;
          }
          .base_logo {
            width: 60px;
            height: 60px;
            img {
              width: 100%;
            }
          }
        }
      }
      .header {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #fff;
        .title {
          font-size: 36px;
          margin: 86px 0 27px 0;
        }
        .userInfo {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          .name {
            margin-right: 50px;
          }
        }
      }

      .main {
        width: auto;
        margin: 25px 30px 30px 30px;
        padding: 40px 40px 300px 40px;
        background: #fff;
        border-radius: 41px 41px 41px 41px;
        box-sizing: border-box;
        .test {
          display: flex;
          flex-direction: column;
          align-items: center;
          .test_content {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            .left_logo {
              width: 25px;
              height: 15px;
              margin-right: 12px;
              img {
                width: 100%;
              }
            }
            .left_title {
              font-size: 16px;
              color: #333;
              font-weight: bold;
              margin-right: 10px;
            }
            .x {
              width: 400px;
              height: 1px;
              background: #e2e2e2;
              border-radius: 0px 0px 0px 0px;
              opacity: 1;
            }
            .right_title {
              width: 90px;
              height: 20px;
              font-size: 7px;
              color: #c7c3c3;
              border-bottom: solid 2px #d9d9d9;
              margin-bottom: 20px;
              text-align: center;
            }
          }
          .exponent {
            width: 90%;
            height: 33px;
            background: #dae8ff;
            border-radius: 19px 19px 19px 19px;
            opacity: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 47px;
            .left {
              font-size: 16px;
              color: #5c81f2;
              margin-left: 46px;
              span {
                font-weight: bold;
                font-size: 20px;
              }
            }
            .right {
              margin-right: 30px;
              width: 36px;
              height: 36px;
              img {
                width: 100%;
              }
            }
          }
          .result {
            .top {
              .title {
                font-size: 13px;
                color: #666;
                margin-left: 40px;
                .title_t {
                  margin-bottom: 30px; //#FF5925
                }
              }
            }
            .body {
              margin: 20px 30px 0 40px;
              color: #666666;
              .body_top {
                display: flex;
                margin-bottom: 10px;
                .body_header {
                  margin-right: 10px;
                }
                .body_title {
                  font-size: 14px;
                  font-weight: bold;
                }
              }
              .body_btn {
                margin-left: 15px;
                font-size: 13px;
                .a {
                  margin-top: 100px;
                }
              }
            }
          }
        }
      }
      //google chrome explore
      -webkit-print-color-adjust: exact;
      //firefox  explore
      -moz-print-color-adjust: exact;
      color-adjust: exact;
    }
  }
}
</style>
